import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { px } from '~/core/scripts/chart-components/utils';
import Icon from '~/core/scripts/components/Icon';

class CallToAction extends PureComponent {
  static propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    margin: PropTypes.object,
    label: PropTypes.string,
    isVisible: PropTypes.bool,
    isLocked: PropTypes.bool,
    onUnlock: PropTypes.func
  }

  static defaultProps = {
    width: 0,
    height: 0,
    margin: {},
    label: '',
    isVisible: false,
    isLocked: false,
    onUnlock: () => {}
  }

  render() {
    const { width, margin, label, isVisible, onUnlock, isLocked } = this.props;

    if (!isVisible) {
      return null;
    }

    const CtaClasses = classnames('youdrawit__cta', {
      'youdrawit__cta--has-button': isLocked
    });

    return (
      <div className={CtaClasses} style={{
        width: px(width),
        top: px(margin.top),
        right: px(margin.right)
      }}>
          <div className="youdrawit__cta-label">
            {label}
          </div>
          {isLocked && (
            <div className="youdrawit__cta-button">
              <button className="btn" onClick={onUnlock}>Jetzt zeichnen <Icon type="pen" /></button>
            </div>
          )}
      </div>
    );
  }
}
export default CallToAction;